const Color = {
  lightGreen: '#50BD64',
  white: '#FFFFFF',
  pink: '#FCE4EC',
  danger: '#EC407A',
  dangerDark: '#C2185B',
  lightNavyBlue: '#3A3E52',
  darkNavyBlue: '#202232',
  denim: '#1F1F2C',
  gray: '#575757',
  lightGray: '#9496A0',
  red: '#E24242',
  green: '#008000',
  disabled: '#696969',
  blurBlack: 'rgba(0,0,0,0.5)',
  black: '#000000',
};

export default Color;
